module.exports = __webpack_public_path__ + "static/img/home-top-background-2.f2874ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/home-top-background-2.jpg
// module id = 68aA
// module chunks = 2